import { render, staticRenderFns } from "./ModalUserData.vue?vue&type=template&id=77c13780&scoped=true&lang=pug&"
import script from "./ModalUserData.vue?vue&type=script&lang=ts&"
export * from "./ModalUserData.vue?vue&type=script&lang=ts&"
import style0 from "./ModalUserData.vue?vue&type=style&index=0&id=77c13780&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c13780",
  null
  
)

export default component.exports